<ng-container *transloco="let t">
  @if (jobShareListFT()) {
    <div class="file-upload">
      <div class="file-upload__container">
        <label class="btn __ghost input-overlay">
          <ic-upload-files
            [color]="'#222222'"
            [size]="40" />
          <span>{{ t('common.upload-file-label') }}</span>
          <span>{{ t('common.upload-file-label-description') }}</span>
          <input
            type="file"
            multiple
            (change)="upload($event)" />
        </label>
      </div>

      @if (files().length > 0) {
        <div class="file-upload__resume">
          @for (file of files(); track file._index) {
            <div class="file-upload__resume-block">
              <div class="file-upload__block-left">
                @if (file.inProgress) {
                  <i class="spinner"></i>
                }
                @if (file.id && !file.error) {
                  <ic-file-document
                    [color]="'#666666'"
                    [size]="20" />
                } @else if (file.error) {
                  <ic-alert-circle
                    [color]="'#ee4242'"
                    [size]="20" />
                }

                @if (file.name) {
                  <span [class.text-red]="file.error">{{ file.name | filenameShortener }}</span>
                }
              </div>

              @if (file.error) {
                <span class="text-red"> {{ t(file.error) }}</span>
              } @else if (!file.inProgress) {
                <div class="file-upload__close-icon">
                  <app-icon
                    name="close"
                    (click)="cancelFile(file._index)" />
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="resume-uploader">
      @if (files().length && showLabel()) {
        <div class="job-advert_subtitle">
          {{ t('quick-apply-form.additional-files') }}
        </div>
      }

      @for (file of files(); track file) {
        <div
          class="hum-form_file_wrap"
          [class.__has-error]="file.error">
          <div
            class="hum-form_file"
            ngPreserveWhitespaces>
            @if (file.inProgress) {
              <app-icon
                name="image-uploader-spinner"
                class="resume-uploader_icon __spinner" />
            }
            @if (file.id) {
              <app-icon
                name="image-uploader-checkmark"
                color="#2ecc71"
                class="resume-uploader_icon" />
            }
            @if (file.name) {
              <span>{{ file.name | filenameShortener }}</span>
            } @else {
              <i class="spinner"></i>
            }
            <app-icon
              name="close"
              (click)="cancelFile(file._index)" />
            @if (file.error) {
              <div class="message __error hum-form_file_error">
                {{ t(file.error) }}
              </div>
            }
          </div>
        </div>
      }
      <div class="file-upload_hint-wrap">
        <label [ngClass]="customClass() || 'input-overlay btn __transparent-blue __s'">
          {{ t('quick-apply-form.add-files') }}
          <input
            type="file"
            multiple
            (change)="upload($event)" />
        </label>
        <i
          class="hint-icon"
          [appTooltip]="t('quick-apply-form.add-files-hint')"></i>
      </div>
    </div>
  }
</ng-container>
